import { secureModeFirmwareVersions } from '../../../../helpers/constants';

export default {
	title: 'settings',
	components: [
		{ title: 'eco_mode', component: 'eco_mode_g2' },
		{
			title: 'enhanced_security',
			component: 'enhanced_security_g2',
			min_ver: secureModeFirmwareVersions,
		},
		{ title: 'device_profile', component: 'pro3em_profile' },
		{
			title: 'reverse_measurement_direction',
			component: 'reverse_measurement_direction_g2',
		},
		{ title: 'change_ct_type', component: 'change_ct_type', min_ver: '1.4.0' },
		{ title: 'blink_mode_selector', component: 'blink_mode_selector' },
		{ title: 'led_phase_selector', component: 'phase_selector' },
		{ title: 'phase_calibration', component: 'phase_to_phase_g2' },
		{
			title: 'phase_calibration_reset',
			component: 'phase_calibration_reset_g2',
		},
		{ title: 'monitor_phase_sequence', component: 'monitor_phase_sequence_g2' },
		{ title: 'delete_stored_data', component: 'delete_stored_data_g2' },
		{ title: 'device_name', component: 'device_name_g2' },
		{ title: 'firmware_version', component: 'firmware_update' },
		{ title: 'geo_location_and_time_zone', component: 'location_g2' },
		{ title: 'device_reboot', component: 'device_reboot' },
		{ title: 'factory_reset', component: 'factory_reset' },
		{ title: 'device_information', component: 'device_information' },
	],
};
